// extracted by mini-css-extract-plugin
export var label = "_fx-2";
export var slideContainer = "_fx-0";
export var slider = "_fx-1";